'use strict';

const ElementModel = require('system/domain/entity/element');
const RelationTypeStore = require('system/domain/repository/relation-type');
require('d3');

const LinkModel = ElementModel.extend({
    kind: 'link',
    defaults: {
        creating: false,
        deleted: false,
        deleting: false,
        name: '',
        description: ''
    },

    _setProperty: function(name) {
        Object.defineProperty(this, name, {
            get: function() {
                return this.get(name);
            },
            set: function(val) {
                return this.set(name, val);
            },
            configurable: true
        });
    },

    /**
     * Link Model のベースクラス。
     *
     * 直接 new されることは無く、LinkModel.define により
     * 子クラスが定義され LinkModel.create により instantiate される。
     * @extends module:models/diagram/element-model.ElementModel
     * @constructs
     */
    initialize: function() {
        LinkModel.__super__.initialize.apply(this, arguments);
        this.setSource();
        this.setTarget();
        this.on('change:source', this.setSource);
        this.on('change:target', this.setTarget);
        this.on('select', function(){
            this.source.highlight();
            this.target.highlight();
        });
        this.on('deselect', function(){
            this.source.dehighlight();
            this.target.dehighlight();
        });
    },

    setSource: function(){
        this._setProperty('source');

        this.listenTo(this.source, 'change', function(){
            this.trigger('change', this);
        });
        this.listenTo(this.source.meta, 'move', function(){
            this.trigger('move')
        });
        this.listenTo(this.source, 'remove', function(opts){
            this.remove(opts);
        });
        this.listenTo(this.source, 'select', function(opts){
            this.highlight(opts);
        });
        this.listenTo(this.source, 'deselect', function(opts){
            this.dehighlight(opts);
        });
    },

    setTarget: function(){
        this._setProperty('target');

        this.listenTo(this.target, 'change', function(){
            this.trigger('change', this);
        });
        this.listenTo(this.target.meta, 'move', function(){
            this.trigger('move')
        });
        this.listenTo(this.target, 'remove', function(opts){
            this.remove(opts);
        });
        this.listenTo(this.target, 'select', function(opts){
            this.highlight(opts);
        });
        this.listenTo(this.target, 'deselect', function(opts){
            this.dehighlight(opts);
        });
    },

    toJSON: function() {
        var j = LinkModel.__super__.toJSON.call(this);
        j.target = this.target.id;
        j.source = this.source.id;
        return j;
    },

    /**
     * link が - y 軸に対してなす角を返す。
     *
     * source から見て target が SVG coordinate で
     * - y 方向(画面上部方向)に存在する場合に 0 が
     * + x 方向(右側)に存在する場合に 90 が返る
     * (つまり時計の 12 時方向を 0 、3 時方向を 90 として扱う)
     *
     * @returns {number}
     */
    angle: function() {
        return Math.atan2(
                (this.target.meta.x - this.source.meta.x),
                - (this.target.meta.y - this.source.meta.y)
            ) / Math.PI * 180;
    },

    /**
     * @typedef Position
     * @type {Object}
     * @property {number} x The x coordinate.
     * @property {number} y The y coordinate.
     */

    /**
     * link された 2 つの node の間の内分点を返す。
     *
     * ratio が 1 ならば target の node のポジションが
     * 0 ならば source の node のポジションが返ってくる。
     *
     * @param {number} [ratio=0.5] - 0 から 1 までの float
     * @return {Position}
     */
    pos: function(ratio) {
        ratio = ratio ? ratio : 0.5;
        return {
            x: d3.interpolate(this.source.meta.x,
                this.target.meta.x)(ratio),
            y: d3.interpolate(this.source.meta.y,
                this.target.meta.y)(ratio)
        };

    },

    i18nType: function() {
        var type = this.get('type');
        return RelationTypeStore.getRelationTypes().get(type)
            .get('name');
    }
}, {
    _classes: {},

    // default パラメータをここで定義しておく
    defaults: {
        creating: false,
        deleting: false,
        name: '',
        description: ''
    }
});

module.exports = LinkModel;



// WEBPACK FOOTER //
// ./system/domain/entity/link.js